import type { ReactNode } from 'react';

// Semantic tones (design-spec.md §1).
export type BadgeTone =
  | 'healthy'
  | 'watch'
  | 'critical'
  | 'progress'
  | 'draft'
  | 'done'
  | 'ai'
  | 'sent';

const tones: Record<BadgeTone, string> = {
  healthy: 'bg-green-600 text-white',
  watch: 'bg-amber-500 text-white',
  critical: 'bg-red-500 text-white',
  progress: 'bg-blue-100 text-blue-700',
  draft: 'bg-slate-200 text-slate-600',
  done: 'bg-green-100 text-green-700',
  ai: 'bg-violet-100 text-violet-700',
  sent: 'bg-sky-100 text-sky-700',
};

export function Badge({ children, tone = 'draft' }: { children: ReactNode; tone?: BadgeTone }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${tones[tone]}`}
    >
      {children}
    </span>
  );
}
